export default "__VITE_ASSET__d1e77a61__"